import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { snakeCaseTransformer, camelCaseTransformer } from '@sondermind/utilities/tools';
import {
  IAPIFetchRequestOptions,
  IAPIFetchResponse
} from '@sondermind/utilities/models-http';

import {
  IOctaveDetails,
  IOctaveUpsertPatientRequest
} from '../models/octave-details.model';

@Injectable({
  providedIn: 'root'
})
export class OctaveHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {}

  getDetails$(opts: Partial<IAPIFetchRequestOptions> = {}): Observable<IOctaveDetails> {
    const url = `${this.indexUrl}/get_details`;
    const params = this.http.generateFetchParams(opts);

    return this.http
      .get<IAPIFetchResponse<IOctaveDetails>>(url, params)
      .pipe(
        map((resp) => camelCaseTransformer<IOctaveDetails>(resp.data)),
        this.http.handleHttpError(opts.error)
      ) as Observable<IOctaveDetails>;
  }

  upsertPatient$(
    body: IOctaveUpsertPatientRequest,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<IOctaveDetails> {
    const url = `${this.indexUrl}/upsert_patient`;

    return this.http
      .post<IAPIFetchResponse<IOctaveDetails>>(url, snakeCaseTransformer(body))
      .pipe(
        map((resp) => camelCaseTransformer<IOctaveDetails>(resp.data)),
        this.http.handleHttpError(opts.error)
      ) as Observable<IOctaveDetails>;
  }

  private get indexUrl(): string {
    return `${this.configurationService.env.svcBase}/billing/octave`;
  }
}
